import "./DashboardPage.css";

import Hero4 from "../../components/Home/Hero4";
import Ticker from "../../components/Home/Ticker";
import ProductCards from "../../components/Home/ProductCards";
import ServicesIndex from "../../components/Home/ServicesIndex";
import StatsBand from "../../components/Home/StatsBand";
import CompareTable from "../../components/Home/CompareTable";
import StepsSection from "../../components/Home/StepsSection";
import PortfolioTeaserHome from "../../components/Home/PortfolioTeaserHome";
import CalcTeaser from "../../components/Home/CalcTeaser";
import AlgoDesk from "../../components/Home/AlgoDesk";
import BusinessCards from "../../components/Home/BusinessCards";
import TeamHome from "../../components/Home/TeamHome";
import TestimonialsHome from "../../components/Home/TestimonialsHome";
import LearnFaq from "../../components/Home/LearnFaq";
import ContactCta from "../../components/Home/ContactCta";
import LatestInsights from "../../components/Dashboard/LatestInsights";

const DashboardPage = () => {
  return (
    <main className="poonjim-dashboard-page">
      <Hero4 />
      <Ticker />
      <ProductCards />
      <ServicesIndex />
      <StatsBand />
      <CompareTable />
      <StepsSection />
      <PortfolioTeaserHome />
      <CalcTeaser />
      <AlgoDesk />
      <BusinessCards />
      <TeamHome />
      <TestimonialsHome />
      <LearnFaq />
      <LatestInsights />
      <ContactCta />
    </main>
  );
};

export default DashboardPage;
